import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class ToastrService {

  constructor(private snackBar: MatSnackBar) {}

  info(message: string, title = '') {
    this.show(message, title, 3000, 'toast-info');
  }

  success(message: string, title = '') {
    this.show(message, title, 1100, 'toast-success');
  }

  warning(message: string, title = '') {
    this.show(message, title, 3000, 'toast-warning');
  }

  error(message: string, title = '') {
    this.show(message, title, 5000, 'toast-error');
  }

  fatal(message: string, title = '') {
    this.show(message, title, 5000, 'toast-error', 'Dismiss');
  }

  private show(message: string, title: string, duration: number, panelClass: string, action = 'Close') {
    const text = title ? `${title}: ${message}` : message;
    this.snackBar.open(text, action, {
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass,
    });
  }

}
